export default __webpack_public_path__ + "static/media/social-play-logo-vertical.172e2a6a.png";